"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**  start-no-seo */
const get_1 = __importDefault(require("lodash/get"));
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
/** end-no-seo */
const mobx_1 = require("mobx");
/**  start-no-seo */
const getFeatures_1 = __importDefault(require("../factories/utils/fleetgroup/getFeatures"));
const getImages_1 = __importDefault(require("../factories/utils/fleetgroup/getImages"));
/** end-no-seo */
const mapInitialStateToStoreState_1 = __importDefault(require("../utils/store/mapInitialStateToStoreState"));
/**  start-no-seo */
const addOn_store_1 = __importDefault(require("./addOn.store"));
const insurance_store_1 = __importDefault(require("./insurance.store"));
const promoCode_store_1 = __importDefault(require("./promoCode.store"));
/** end-no-seo */
/**
 * Fleet Details Page Store
 * Consumes AddOn, Insurance stores
 * Maintains Fleet/Car Details Page related data and state
 */
class FleetDetailsPageStore {
    constructor(initialState = {}, $env) {
        this.fleetDetails = {};
        /** end-no-seo */
        this.isBookingFlow = false;
        /**
         * Action to update fleet details observable
         * @param {FleetGroupFactoryType} fleetObj
         */
        this.updateFleetDetails = (fleetObj) => {
            this.fleetDetails = Object.assign({}, fleetObj);
        };
        /** end-no-seo */
        /**
         * Action to set booking flow
         * Needs to be set when user hits continue button on fleet details page
         * @param {boolean} status
         */
        this.setIsBookingFlow = (status) => {
            this.isBookingFlow = status;
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.$env = $env;
        this.updateInitialState(initialState);
        /**  start-no-seo */
        // initialize domain stores
        this.addOn = new addOn_store_1.default(initialState.addOn, $env);
        this.insurance = new insurance_store_1.default(initialState.insurance, $env);
        this.promoCode = new promoCode_store_1.default(initialState.promoCode, $env);
        /** end-no-seo */
    }
    /**
     * Returns current config language
     * @returns {boolean}
     */
    get language() {
        return this.$env.config.locale;
    }
    /**  start-no-seo */
    /**
     * Returns true if fleetDetails is empty
     * @returns {boolean}
     */
    get isEmpty() {
        return (0, isEmpty_1.default)(this.formattedFleetDetails);
    }
    /**
     * Returns formatted fleet details
     * eg. removes observable features/images array
     */
    get fleetDetailsFactory() {
        return Object.assign(Object.assign({}, this.fleetDetails), { features: (0, getFeatures_1.default)((0, get_1.default)(this.fleetDetails, 'features', []), this.language), images: (0, getImages_1.default)((0, get_1.default)(this.fleetDetails, 'images', [])) });
    }
    /**
     * Returns fleet details
     * Use this props in front end side
     * @returns {Object}
     */
    get formattedFleetDetails() {
        return this.fleetDetailsFactory;
    }
}
__decorate([
    mobx_1.observable
], FleetDetailsPageStore.prototype, "fleetDetails", void 0);
__decorate([
    mobx_1.observable
], FleetDetailsPageStore.prototype, "isBookingFlow", void 0);
__decorate([
    mobx_1.computed
], FleetDetailsPageStore.prototype, "language", null);
__decorate([
    mobx_1.computed
], FleetDetailsPageStore.prototype, "isEmpty", null);
__decorate([
    mobx_1.computed
], FleetDetailsPageStore.prototype, "fleetDetailsFactory", null);
__decorate([
    mobx_1.computed
], FleetDetailsPageStore.prototype, "formattedFleetDetails", null);
__decorate([
    mobx_1.action.bound
], FleetDetailsPageStore.prototype, "updateFleetDetails", void 0);
__decorate([
    mobx_1.action.bound
], FleetDetailsPageStore.prototype, "setIsBookingFlow", void 0);
__decorate([
    mobx_1.action.bound
], FleetDetailsPageStore.prototype, "updateInitialState", void 0);
exports.default = FleetDetailsPageStore;
